<template>
    <div id="regPage">
        <div id="loading">
            <h1>Loading</h1>
            <span>.</span><span>.</span><span>.</span>
        </div>
        <div classs="row">
            <div class="col-sm-2 col-xs-0"></div>
            <div class="col-sm-8 col-xs-12" id="placeForCanvas"></div>
            <div class="col-sm-2 col-xs-0"></div>
        </div>
        <div id="formParts">
            <!--Owner Information -->
            <div id="newOrCurTitleNum">
                <span v-if="data.MVNewTitleNo !== ''">
                    {{data.MVNewTitleNo}}
                </span>
                <span v-else>
                    {{data.MVCurrentTitleNo}}
                </span>
            </div>
            <div id="transactionCode">{{data.MVTransType}}</div>
            <div id="ownerLegalStatus"></div>
            <div id="ownerStatus"></div>
            <div id="ownerType">{{data.MVOwnerNameCode}}</div>
            <div id="nNumber1">{{data.MVMAOCode}}</div>
            <div id="nNumber2">{{data.MVILUCode}}</div>
            <div id="ownerLastName1">
                {{data.MVOwner1LastName}}
            </div>
            <div id="ownerFirstName1">
                {{data.MVOwner1FirstName}}
            </div>
            <div id="ownerMiddleInitial1"></div>
            <div id="ownerStreet1">
                {{data.MVOwnerStreetNo + data.MVOwnerAddress}}&nbsp;&nbsp;&nbsp;&nbsp;%&nbsp;&nbsp;&nbsp;&nbsp;
                {{data.MVIncareOfName}}
            </div>
            <div id="ownerCity1">
                {{data.MVOwnerCity}}
            </div>
            <div id="ownerState1">
                {{data.MVOwnerState}}
            </div>
            <div id="ownerZip1">
                {{data.MVOwnerZip}}
            </div>
            <div id="ownerCounty1">
                HAMILTON 033
            </div>
            <div id="purchaseDate">
                {{data.MVPurchaseDate}}
            </div>
            <div id="ownerPhoneNumber1">
                {{data.MVOwnerPhoneNo}}
            </div>
            <!--Vehicle Information -->
            <div id="vin">
                {{data.MVVIN}}
            </div>
            <div id="make">
                {{data.MVMake}}
            </div>
            <div id="model">
                {{data.MVModel}}
            </div>
            <div id="year">
                {{data.MVYear}}
            </div>
            <div id="carBody">
                {{data.MVBody}}
            </div>
            <div id="titleBrand" ></div>
            <div id="titleBrandCode">
                {{data.MVNewUsedCode}}
            </div>
            <div id="fuelType"></div>
            <div id="fuelTypeCode">
                {{data.MVFuel}}
            </div>
            <div id="previousTitleNumber">
                {{data.MVFormerTitleNo}}
            </div>
            <div id="previousTitleState">
                {{data.MVPrevTitleState1}}
            </div>
            <div id="odometerIndicator">1</div>
            <div id="grossWeight">
                {{data.MVGrossWeight}}
            </div>
            <div id="NoAxles">
                {{data.MVAxleCount}}
            </div>
            <div id="carColor">
                {{data.MVColor}}
            </div>
            <div id="vehicleUse">
                {{data.MVVehicleUse}}
            </div>
            <div id="vehicleType">
                {{data.MVVehicleType}}
            </div>
            <!--Plate Information-->
            <div id="licenseNumber">
                {{data.MVLicenseNo}}
            </div>
            <div id="classCode">
                {{data.MVTransClass}}/{{data.MVIssueYear}}
            </div>
            <div id="expirationDate">
                PERMANENT
            </div>
            <!--Bottom Section -->
            <div id="countyName">HAMILTON</div>
            <div id="countyNumber">33</div>
            <div id="today"></div>
            <div id="printedBy"></div>
            <div id="currentDate">{{data.currentDate}}</div>
            <div id="invoiceNo">{{data.MVInvoiceNo}}</div>
            <div id="applicationDate">{{data.MVTransDate}}</div>
            <div id="userName">{{data.MVUserName}}</div>
            <div id="regFee">{{data.MVLicenseFee}}</div>
            <div id="issuanceFee">{{data.MVLicenseIssuanceFee}}</div>
            <div id="titleFee">{{data.MVTitleFee}}</div>
            <div id="totalFee">{{data.MVTotalDue}}</div>
            <div id="terminal">{{data.MVTerminal}}/DR{{data.MVDrawer}}/{{data.MVTransClass}}</div>
            <div id="checkAmount">{{data.MVCheckAmount}}</div>
            <div id="checkNo">{{data.MVCheckNo}}</div>
            <div id="emissionControlNo">{{data.MVEmissionControlNo}}</div>
            <img :src="data.barcode64bin" id="barcode" alt=""/>
            <img :src="data.formBin64" id="formBackground" alt=""/>
            <div v-if="data.lienInfo !== undefined" id="lienInfo">
                <div id="lienCode1">{{data.lienInfo[0].LienCode}}</div>
                <div id="lienName1">{{data.lienInfo[0].LienHolderName}}</div>
                <div id="lienDate1">{{data.lienInfo[0].LienDate}}</div>
                <div id="lienStreet1">{{data.lienInfo[0].LienStreetNo}} {{data.lienInfo[0].LienStreetName}}</div>
                <div id="lienCity1">{{data.lienInfo[0].LienCity}}</div>
                <div id="lienState1">{{data.lienInfo[0].LienState}}</div>
                <div id="lienZip1">{{data.lienInfo[0].LienZip}}</div>
                <div v-if="data.lienInfo[1] !== undefined">
                    <div id="lienCode2">{{data.lienInfo[1].LienCode}}</div>
                    <div id="lienName2">{{data.lienInfo[1].LienHolderName}}</div>
                    <div id="lienDate2">{{data.lienInfo[1].LienDate}}</div>
                    <div id="lienStreet2">{{data.lienInfo[1].LienStreetNo}} {{data.lienInfo[1].LienStreetName}}</div>
                    <div id="lienCity2">{{data.lienInfo[1].LienCity}}</div>
                    <div id="lienState2">{{data.lienInfo[1].LienState}}</div>
                    <div id="lienZip2">{{data.lienInfo[1].LienZip}}</div>
                </div>
            </div>
        </div>
</template>

<script>
  import axios from 'axios'
  import html2canvas from 'html2canvas'
  // import jsPDF from 'jspdf'

  export default {
    name: 'registration-page',
    prop: ['print'],
    data () {
      return {
        data: ''
      }
    },
    created () {
      axios.post('./static/api/Ajax.php', {
        action: 'Get Vin Data'
      }).then((response) => {
        this.data = response.data
        html2canvas(document.querySelector('#formParts')).then(function (canvas) {
          let data = canvas.toDataURL()
          let img = document.createElement('img')
          img.setAttribute('download', 'myImage.png')
          img.src = data
          let node = document.querySelector('#formParts')
          node.parentNode.removeChild(node)
          node = document.querySelector('#loading')
          node.parentNode.removeChild(node)
          document.getElementById('regPage').removeAttribute('id')
          document.querySelector('#placeForCanvas').appendChild(img)
        })
      }).catch((e) => {
        console.log(e)
      })
    }
  }
</script>

<style scoped>
    #regPage{
        overflow:hidden;
        top: 0;
        left: 0;
        position: fixed;
        width: 100%;
        height: 100%;
    }
    #loading{
        font-family:Lucida Grande, Helvetica, Verdana, sans-serif;
        background:rgba(0,0,0,1);
        color:#f2f2f2;
        overflow:hidden;
        top: 0;
        left: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }
    #loading h1{position:absolute;top:50%;left:50%;height:40px;line-height:40px;width:160px;margin:-20px 0 0 -80px;text-align:center;font-weight:normal;}
    #loading span{-webkit-animation:load 4s infinite ease-in-out;position:absolute;top:51%;height:10px;width:30px;text-align:right;font-size:200%;margin-left:-15px;}
    #loading span:nth-child(2){-webkit-animation-delay:.2s;width:20px;}
    #loading span:nth-child(3){-webkit-animation-delay:.4s;width:10px;}
    @-webkit-keyframes load{
        0%{left:-2%;}
        40%{left:50%;}
        60%{left:50%;}
        100%{left:102%;}
    }
</style>


// WEBPACK FOOTER //
// src/components/registrationPage.vue